import { UNKNOWN_ROLE } from '@/shared/constants/roles';
import {
  INCREASE_USER_RECORDINGS, SET_AUTH_TOKEN,
  SET_EMAIL,
  SET_IS_CHANGE_PROTOCOL,
  SET_IS_DISABLED_CLICK_OUTSIDE,
  SET_IS_INSTALL_APP, SET_IS_MOBILE,
  SET_ROLE,
  SET_USER_DATA,
  SET_DID_LOGIN,
  SET_USER_COUNTRY,
} from '@/shared/constants/mutationTypes';
import { LocalStorageKey, SessionStorageKey } from '@/shared/constants/storageKeys';

const state = {
  role: UNKNOWN_ROLE,
  user: {},
  isInstallApp: true,
  isChangeProtocol: false,
  email: localStorage.getItem(LocalStorageKey.EMAIL) ?? '',
  isMobile: false,
  isDisabledClickOutside: false,
  authToken: localStorage.getItem(LocalStorageKey.AUTH_TOKEN) ?? null,
  didLogin: !!sessionStorage.getItem(SessionStorageKey.DID_LOGIN),
};
const getters = {
  role: state => state.role,
  email: state => state.email,
  user: state => state.user,
  isInstallApp: state => state.isInstallApp,
  isChangeProtocol: state => state.isChangeProtocol,
  isMobile: state => state.isMobile,
  isDisabledClickOutside: state => state.isDisabledClickOutside,
  authToken: state => state.authToken,
  didLogin: state => state.didLogin,
};
const actions = {
  setAuthToken({ commit }, token) {
    if (token) {
      localStorage.setItem(LocalStorageKey.AUTH_TOKEN, token);
    } else {
      localStorage.removeItem(LocalStorageKey.AUTH_TOKEN);
    }
    commit(SET_AUTH_TOKEN, token);
  },
  didLogin({ commit }, data) {
    commit(SET_DID_LOGIN, data);
  },
  setRole({ commit }, data) {
    commit(SET_ROLE, { data });
  },
  setEmail({ commit }, data) {
    localStorage.setItem(LocalStorageKey.EMAIL, data);
    commit(SET_EMAIL, { data });
  },
  setUserData({ commit, state }, data) {
    commit(SET_USER_DATA, { ...state.user ,data });
  },
  setIsInstallApp({ commit }, data) {
    commit(SET_IS_INSTALL_APP, data);
  },
  isChangeProtocol({ commit }, data) {
    commit(SET_IS_CHANGE_PROTOCOL, data);
  },
  setIsMobile({ commit }, data) {
    commit(SET_IS_MOBILE, data);
  },
  setIsDisabledClickOutside({ commit }, data) {
    commit(SET_IS_DISABLED_CLICK_OUTSIDE, data);
  },

  // addNewMessage({ commit }, data) {
  //   commit(ADD_NEW_MESSAGE, { data });
  // },
  increaseUserRecordings({ commit }) {
    commit(INCREASE_USER_RECORDINGS);
  },
};
const mutations = {
  [SET_AUTH_TOKEN](state, token) {
    state.authToken = token;
  },
  [SET_ROLE](state, { data }) {
    state.role = data;
  },
  [SET_EMAIL](state, { data }) {
    state.email = data;
  },
  [SET_USER_DATA](state, { data }) {
    state.user = data;
  },
  [SET_IS_INSTALL_APP](state, data) {
    state.isInstallApp = data;
  },
  [SET_IS_CHANGE_PROTOCOL](state, data) {
    state.isChangeProtocol = data;
  },
  [SET_IS_MOBILE](state, data) {
    state.isMobile = data;
  },
  [SET_IS_DISABLED_CLICK_OUTSIDE](state, data) {
    state.isDisabledClickOutside = data;
  },
  [INCREASE_USER_RECORDINGS](state) {
    state.user.recordings++;
  },
  [SET_DID_LOGIN](state, data){
    if (data) {
      sessionStorage.setItem(SessionStorageKey.DID_LOGIN, true);
    } else  {
      sessionStorage.removeItem(SessionStorageKey.DID_LOGIN);
    }
    state.didLogin = !!data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
